import css from 'styled-jsx/css'
import { colors, fontSizes } from 'theme'

export default css`
  .error-feedback-wrapper {
    text-align: left;
    font-size: ${fontSizes.body};
  }
  .margin-top-one-rem {
    margin-top: 1rem;
  }
`

export const listErrorsStyles = css`
  .error-feedback-wrapper {
    color: ${colors.danger};
  }
`